module.exports = __webpack_public_path__ + "media/images/Lab-Logo-ba25a4acfd8b356f9b5b50e8857302f8.svg";